function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.008 2.697l-.131-.106C7.225.503 3.576.375 1.44 2.779c-2.114 2.382-1.82 5.907.358 8.672.539.687 1.222 1.46 2.03 2.307.37.388.765.789 1.181 1.201a93.17 93.17 0 002.319 2.216l1.395 1.273.77.697.068.053c.081.057.142.07.445.128l.186-.037c.199-.04.22-.058.328-.144l1.555-1.383a80.745 80.745 0 002.964-2.784 48.775 48.775 0 001.573-1.63 26.692 26.692 0 001.612-1.91c2.146-2.836 2.449-6.293.348-8.659-2.135-2.403-5.763-2.276-8.427-.193l-.137.111z",
  fillRule: "nonzero",
  fill: "#0079bf"
});

function SvgHeartActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHeartActive;